import React from 'react';
import Sidebar from './Sidebar';
import { GridProvider } from '@/context/GridContext';
import { AlertProvider } from '@/context/AlertContext';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <AlertProvider>
      <GridProvider>
        <div className="flex h-screen w-screen overflow-hidden bg-background text-foreground">
          <Sidebar />
          <main className="flex-1 overflow-hidden relative">
            {children}
          </main>
        </div>
      </GridProvider>
    </AlertProvider>
  );
}